<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.ALI.database.stateName") }}</span>
          <span class="expand-value">{{ row.stateName }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.ALI.database.databaseCreatedTime")
          }}</span>
          <span class="expand-value">{{ row.databaseCreatedTime }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.GCP.RelationalDataBaseResource.project") }}
          </span>
          <span class="expand-value">{{ row.project }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.GCP.RelationalDataBaseResource.backupPolice") }}
          </span>
          <span class="expand-value">{{ row.backupPolice }}</span>
        </Col>
      </Row>
      <Row class="expand-row"> </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      subnetData: this.row.resourceSubnetList,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/rds/TableExpand.vue